// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__PZxlX","label":"Radio_label__QskpV","checkMark":"Radio_checkMark__2EXOf","disabled":"Radio_disabled__3dckz"};